module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [(_vm.haveResult) ? _c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('div', {
    staticClass: "kaojicenter-list-box"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "kaojicenter-lists flex-between",
      on: {
        "click": function($event) {
          return _vm.onDownload(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "kaojicenter-rights"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.saiqu_name))]), _vm._v(" "), _c('div', {
      staticClass: "desc flex-start"
    }, [_vm._v("\n                                 " + _vm._s(item.mingcheng)), _c('br'), _vm._v("\n                                " + _vm._s(item.name) + " (" + _vm._s(item.num) + ")\n                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "kaojicenter-lefts"
    }, [_vm._v("\n                            下载证书\n                        ")])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": function($event) {
        _vm.addShow = true
      }
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '50%'
    }),
    attrs: {
      "position": "bottom"
    },
    on: {
      "click-overlay": function($event) {
        _vm.addShow = false
      }
    },
    model: {
      value: (_vm.addShow),
      callback: function($$v) {
        _vm.addShow = $$v
      },
      expression: "addShow"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "0.2rem",
      "margin-bottom": "1.5rem"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("如您获得纸质证书，则不提供电子证书下载")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "裁判姓名",
      "rules": [{
        required: true,
        message: '姓名不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "证件号码",
      "rules": [{
        required: true,
        message: '证件号码不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入证件号码"
    },
    model: {
      value: (_vm.params.num),
      callback: function($$v) {
        _vm.$set(_vm.params, "num", $$v)
      },
      expression: "params.num"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中...",
      "native-type": "submit"
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "width": "80%",
      "height": "auto",
      "text-align": "center"
    },
    model: {
      value: (_vm.showCert),
      callback: function($$v) {
        _vm.showCert = $$v
      },
      expression: "showCert"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "height": "auto"
    },
    attrs: {
      "src": _vm.certUrl
    }
  }), _vm._v(" "), (!_vm.isApp) ? _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    }
  }, [_vm._v("请长按图片保存")]) : _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": _vm.appDownload
    }
  }, [_vm._v("点击下载证书")])], 1), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.certLoading
    }
  }, [_c('van-loading', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "200px"
    },
    attrs: {
      "type": "spinner"
    },
    model: {
      value: (_vm.certLoading),
      callback: function($$v) {
        _vm.certLoading = $$v
      },
      expression: "certLoading"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fad657a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cha/CaipanList.vue
// module id = 2369
// module chunks = 0